import axios from "axios";

const admin = JSON.parse(localStorage.getItem("ADMIN"));

if (admin) {
  axios.defaults.headers.common["x-access-token"] = admin.token;
}
axios.defaults.headers.common["platform"] = "AdminWeb";

export default {
  WorkshopApis(url = `${process.env.REACT_APP_BASE_URL}/api`) {
    return {
      createWorkshop: (data) =>
        axios.post(url + "/workshop/create-workshop", data),
      getAllWorkshops: (data) =>
        axios.post(url + "/workshop/get-all-workshops", data),
      updateWorkshop: (data) =>
        axios.post(url + "/workshop/update-workshop", data),
      getWorkshopById: (workshopId) =>
        axios.get(url + `/workshop/get-workshop/${workshopId}`),
      createOrUpdateCommunityLink: (data) =>
        axios.post(url + "/adminauth/workshop-community-link", data),
      getCommunityLinks: ({ page = 1, limit = 10 } = {}) =>
        axios.get(url + "/adminauth/workshop-community-link/list", {
          params: { page, limit },
        }),
    };
  },
}; 